import React from "react";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaTiktok, FaPhone, FaEnvelope, FaMapMarkerAlt, FaGraduationCap, FaHeart } from "react-icons/fa";
import { HiOutlineMail, HiOutlinePhone, HiOutlineLocationMarker } from "react-icons/hi";
import logoWebp from "../../assets/1.webp";
import logo from "../../assets/1.png";
import Picture from "../../Components/Picture";
import { Link } from "react-router-dom";
import { NAV_LINKS } from "../../content/navigation";
const Footer = () => {
  return (
    <footer id="call" className="relative bg-gradient-to-br from-[#081D3E] via-[#0F2A55] to-[#081D3E] text-white overflow-hidden" dir="rtl">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-32 h-32 bg-blue-400 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 bg-green-400 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-60 h-60 bg-gradient-to-r from-blue-400 to-green-400 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10">
        {/* Main Footer Content */}
        <div className="container mx-auto px-6 py-16">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
            
            {/* Company Info Section */}
            <div className="lg:col-span-2">
              <div className="flex items-center gap-4 mb-6">
                <Picture
                webp={logoWebp}
                fallback={logo}
                alt="Logo"
                width={72}
                height={93}
                loading="eager"
                className="w-16 h-16 object-contain"
              />
                <div>
                  <h3 className="text-2xl font-bold bg-gradient-to-r from-white to-blue-200 bg-clip-text text-transparent">
                    أكاديمية الرواد ابن سينا
                  </h3>
                  <p className="text-blue-200 text-sm">للتدريب الخاص</p>
                </div>
              </div>
              <p className="text-gray-300 leading-relaxed mb-8 max-w-md">
                نضعك على الطريق الصحيح نحو مستقبل مشرق وواعد في مجال الرعاية الصحية. 
                نحن ملتزمون بتقديم أفضل البرامج التدريبية المعتمدة لضمان نجاحك المهني.
              </p>
              
              {/* Social Media */}
              <div className="flex gap-4">
                {[
                  { icon: FaFacebook, href: "https://www.facebook.com/Elrawad.Ibn.Sina", color: "hover:bg-blue-600", label: "Facebook" },
                  { icon: FaTiktok, href: "https://www.tiktok.com/@user1381751316131?_t=ZS-8tlt8WL0Qqu&_r=1", color: "hover:bg-black", label: "TikTok" },
                  { icon: FaInstagram, href: "#", color: "hover:bg-pink-600", label: "Instagram" }
                ].map((social, index) => (
                  <a
                    key={index}
                    href={social.href}
                    className={`w-12 h-12 bg-white/10 backdrop-blur-sm rounded-xl flex items-center justify-center text-white transition-all duration-300 hover:scale-110 hover:shadow-lg ${social.color}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={social.label}
                  >
                    <social.icon className="text-xl" />
                  </a>
                ))}
              </div>
            </div>

            {/* Contact Info Section */}
            <div className="lg:col-span-2">
              <h4 className="text-xl font-bold mb-6 flex items-center gap-2">
                <FaPhone className="text-blue-400" />
                معلومات التواصل
              </h4>
              <div className="space-y-4">
                <div className="flex items-start gap-3 group">
                  <div className="w-10 h-10 bg-blue-500/20 rounded-lg flex items-center justify-center group-hover:bg-blue-500/30 transition-colors duration-300">
                    <HiOutlineLocationMarker className="text-blue-400 text-lg" />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-200 mb-1">العنوان</p>
                    <p className="text-gray-400 text-sm leading-relaxed">
                      امام جامعة طنطا كوبري كفر عصام<br />
                      اعلي اكازيون الدور الاول عمارة ال قنديل
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-3 group">
                  <div className="w-10 h-10 bg-green-500/20 rounded-lg flex items-center justify-center group-hover:bg-green-500/30 transition-colors duration-300">
                    <HiOutlinePhone className="text-green-400 text-lg" />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-200 mb-1">رقم الهاتف</p>
                    {/* py-2 -inline-block: الرابط كان بارتفاع 27–30px، أي دون حدّ اللمس
                      44px الذي يفرضه ملف المعايير. قِسناه بمتصفح حقيقي على 375px. */}
                  <a href="tel:+201020889514" className="inline-flex min-h-11 items-center text-gray-400 hover:text-white transition-colors duration-300" dir="ltr">
                      +20 102 088 9514
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-3 group">
                  <div className="w-10 h-10 bg-purple-500/20 rounded-lg flex items-center justify-center group-hover:bg-purple-500/30 transition-colors duration-300">
                    <HiOutlineMail className="text-purple-400 text-lg" />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-200 mb-1">البريد الإلكتروني</p>
                    <a href="mailto:sales@elrawad-ibn-sina.com" className="inline-flex min-h-11 items-center text-gray-400 hover:text-white transition-colors duration-300">
                      sales@elrawad-ibn-sina.com
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Links Section */}
            <div>
              <h4 className="text-xl font-bold mb-6 flex items-center gap-2">
                <FaGraduationCap className="text-yellow-400" />
                روابط سريعة
              </h4>
              <div className="space-y-3">
                {/* كانت هنا نسخة ثانية من قائمة المراسي نفسها التي كانت في
                    الشريط العلوي، فإصلاح أحدهما يترك الآخر مكسورًا. الاثنان
                    يقرآن الآن NAV_LINKS — نفس المصدر الذي تُبنى منه المسارات. */}
                {NAV_LINKS.filter((l) => l.path !== "/").map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    className="flex min-h-11 items-center text-gray-400 transition-colors hover:text-white"
                  >
                    {link.label}
                  </Link>
                ))}
                <div className="border-t border-gray-700 pt-3 mt-4">
                  <Link 
                    to="/SingUP" 
                    className="inline-flex min-h-11 items-center gap-2 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white px-4 py-2 rounded-lg font-semibold transition-all duration-300 hover:scale-105 hover:shadow-lg"
                  >
                    <FaHeart className="text-red-400" />
                    اشترك الآن
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700/50">
          <div className="container mx-auto px-6 py-6">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <div className="text-gray-400 text-sm">
                <a 
                  href="https://notfound-agency.com/" 
                  className="hover:text-white transition-colors duration-300"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {/* كان هنا سطر إنجليزي بتاريخ 2024 ثابت: «Copyright © 2024 by
                    NOT FOUND AGENCY. All Rights Reserved.» — على موقع عربي
                    بالكامل، وبسنة تقادمت. السنة تُحسب الآن تلقائيًا. */}
                جميع الحقوق محفوظة © <span className="num">{new Date().getFullYear()}</span> — أكاديمية الرواد ابن سينا
                </a>
              </div>
              
              <div className="flex gap-6 text-sm">
                <Link 
                  to="/privacy-policy"
                  className="inline-flex min-h-11 items-center text-gray-400 hover:text-white transition-colors duration-300"
                >
                  سياسة الخصوصية
                </Link>
                <Link 
                  to="/terms-and-conditions"
                  className="inline-flex min-h-11 items-center text-gray-400 hover:text-white transition-colors duration-300"
                >
                  الشروط والأحكام
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;